import SEOArticlePage from "@/components/feature/SEOArticlePage";
import { articleContents } from "@/mocks/seo-article-content";

export default function OptimiserWorkflow() {
  return <SEOArticlePage article={articleContents["optimiser-workflow"]} />;
}